module.exports = __webpack_public_path__ + "files/cleanhand4.7558e897bf47a2e831e1b4353e965579.pdf";